<template>
  <v-dialog
    v-model="getModalVisualizarVenda"
    persistent
    max-width="1200"
    transition="dialog-transition"
  >
    <v-card outlined :loading="$store.getters.getOverlay">
      <v-card-title
        >Venda Nº {{ getVenda.id }} <v-spacer></v-spacer
        ><v-btn
          color="warning"
          outlined
          @click="cadastrarPosVenda(true)"
          v-if="$helper.verificaPermissao('cadastrar-pos-venda-crm')"
          >Pós-Venda</v-btn
        ></v-card-title
      >
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <td colspan="5">
                  <h3 class="red--text">Produtos:</h3>
                </td>
              </tr>
            </thead>
            <thead>
              <tr>
                <th class="text-left">Cód.</th>
                <th class="text-left">Produto</th>
                <th class="text-left">Pre. Venda</th>
                <th class="text-left">Quant.</th>
                <th class="text-left">Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in getVenda.itens" :key="item.id">
                <td>{{ item.produto_id }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ $helper.formatReal(parseFloat(item.preco_venda)) }}</td>
                <td>{{ item.quantidade }}</td>

                <td>{{ $helper.formatReal(parseFloat(item.total_venda)) }}</td>
                <td colspan="2">
                  <TooltipButton
                    v-if="$helper.verificaPermissao('visualizar-produto')"
                    @click.native="visualizarProduto(item.produto_id)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="edit"
                    color="primary"
                  />
                </td>
              </tr>
              <tr>
                <td colspan="4"><b>Subtotal:</b></td>
                <td colspan="3">
                  {{ $helper.formatReal(parseFloat(getVenda.subtotal)) }}
                </td>
              </tr>
              <tr>
                <td colspan="4"><b>Desconto:</b></td>
                <td colspan="3">
                  {{ $helper.formatReal(parseFloat(getVenda.desconto)) }}
                </td>
              </tr>
              <tr>
                <td colspan="4"><b>Acréscimo:</b></td>
                <td colspan="3">
                  {{ $helper.formatReal(parseFloat(getVenda.acrescimo)) }}
                </td>
              </tr>
              <tr>
                <td colspan="4"><b>Total:</b></td>
                <td colspan="3">
                  {{ $helper.formatReal(parseFloat(getVenda.total)) }}
                </td>
              </tr>
              <tr v-if="getVenda.funcionario">
                <td colspan="7">
                  <b>Vendedor:</b> {{ getVenda.funcionario.nome_abreviado }}
                </td>
              </tr>
              <tr>
                <td colspan="7"><b>Status:</b> {{ getVenda.status }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default v-if="getVenda.cliente">
            <thead>
              <tr>
                <td colspan="2">
                  <h3 class="red--text">Cliente:</h3>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Nome</b></td>
                <td>{{ getVenda.cliente.nome }}</td>
                <td>
                  <TooltipButton
                    @click.native="visualizarContato(getVenda.cliente.id)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="edit"
                    color="primary"
                    v-if="$helper.verificaPermissao('visualizar-contato')"
                  />
                </td>
              </tr>
              <tr>
                <td><b>CPF/CNPJ</b></td>
                <td>{{ getVenda.cliente.cpf_cnpj }}</td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <td colspan="2">
                  <h3 class="red--text">Formas de Pagamento:</h3>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="20%"><strong>Forma</strong></td>
                <td><strong>Valor Pago</strong></td>
              </tr>
              <tr v-for="f in getVenda.formas_pagamento" :key="f.id">
                <td>{{ f.forma }}</td>
                <td>{{ $helper.formatReal(parseFloat(f.valor_pago)) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          outlined
          :loading="$store.getters.getOverlay"
          @click="
            $store.dispatch('ativaModalConfirmacao', {
              mensagem: 'Tem certeza que deseja voltar?',
              action: 'setModalVisualizarVenda',
              action_value: false,
            })
          "
          >Voltar (ESC)</v-btn
        >
        <v-spacer></v-spacer>
        <!--<span v-if="getVenda.status != 'Excluído'"> -->
        <v-btn
          color="warning"
          outlined
          class="mr-1 ml-1"
          @click="trocarMercadoria"
          :loading="$store.getters.getOverlay"
          v-if="
            getModalListarVenda &&
            $helper.verificaPermissao('venda-troca-mercadoria') &&
            getVenda.status != 'Excluído'
          "
          >Trocar Mercadoria</v-btn
        >
        <div class="text-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                dark
                v-bind="attrs"
                v-on="on"
                outlined
                :loading="$store.getters.getOverlay"
                class="ml-1 mr-1"
              >
                NF-e
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="
                  getVenda.estado_nfe != 'APROVADO' &&
                  $helper.verificaPermissao('gerar-nfe') &&
                  getVenda.status != 'Excluído'
                "
                @click="setModalGerarNfe(true)"
              >
                <v-list-item-title>Gerar (F1)</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="
                  getVenda.estado_nfe == 'APROVADO' &&
                  $helper.verificaPermissao('imprimir-nfe')
                "
                @click="imprimirNfe(getVenda.chave_nfe)"
              >
                <v-list-item-title>Imprimir (F1)</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="setModalEnviarNfeEmail(true)"
                v-if="
                  getVenda.estado_nfe == 'APROVADO'
                "
              >
                <v-list-item-title>Enviar por E-mail</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="setModalEstornoNfe(true)"
                v-if="getVenda.estado_nfe == 'APROVADO'"
              >
                <v-list-item-title>Estornar</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="setModalCancelarNfe(true)"
                v-if="getVenda.estado_nfe == 'APROVADO'"
              >
                <v-list-item-title>Cancelar</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="getVenda.estado_nfe == 'APROVADO'"
                @click="setModalCartaCorrecaoNfe(true)"
              >
                <v-list-item-title>CC-e</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="imprimirNfe(getVenda.chave_nfe_estorno)"
                v-if="getVenda.estado_nfe == 'ESTORNADO'"
              >
                <v-list-item-title>Imprimir Estorno</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="baixarXmlNFe(getVenda.path_xml)"
                v-if="getVenda.estado_nfe == 'APROVADO'"
              >
                <v-list-item-title>Baixar XML</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <!-- <v-btn
          color="success"
          outlined
          class="mr-1 ml-1"
          :loading="$store.getters.getOverlay"
          v-if="
            getVenda.estado_nfe != 'APROVADO' &&
            $helper.verificaPermissao('gerar-nfe') &&
            getVenda.status != 'Excluído'
          "
          @click="setModalGerarNfe(true)"
          >Gerar NF-e (F1)</v-btn
        > -->
        <!-- <v-btn
          color="success"
          outlined
          class="mr-1 ml-1"
          :loading="$store.getters.getOverlay"
          v-if="
            getVenda.estado_nfe == 'APROVADO' &&
            $helper.verificaPermissao('imprimir-nfe')
          "
          @click="imprimirNfe(getVenda.chave_nfe)"
          >Imprimir NF-e (F1)</v-btn
        > -->

        <div class="text-center">
          <v-menu offset-y >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                dark
                v-bind="attrs"
                v-on="on"
                outlined
                class="ml-1 mr-1"
                :loading="$store.getters.getOverlay"
              >
                NFC-e
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="setModalGerarNfce(true)"
                v-if="
                  getVenda.estado_nfce != 'APROVADO' &&
                  $helper.verificaPermissao('gerar-nfce') &&
                  getVenda.status != 'Excluído'
                "
              >
                <v-list-item-title>Gerar (F2)</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="
                  getVenda.estado_nfce == 'APROVADO' &&
                  $helper.verificaPermissao('imprimir-nfce')
                "
                @click="imprimirNFCe(getVenda.id)"
              >
                <v-list-item-title>Imprimir (F2)</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="getVenda.estado_nfce == 'APROVADO'"
                @click="setModalCancelarNfce(true)"
              >
                <v-list-item-title>Cancelar</v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="getVenda.estado_nfce == 'APROVADO'"
                @click="baixarXmlNFCe(getVenda.path_xml_nfce)"
              >
                <v-list-item-title>Baixar XML</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <!-- <v-btn
          color="success"
          outlined
          class="mr-1 ml-1"
          :loading="$store.getters.getOverlay"
          v-if="
            getVenda.estado_nfce != 'APROVADO' &&
            $helper.verificaPermissao('gerar-nfce') &&
            getVenda.status != 'Excluído'
          "
          @click="setModalGerarNfce(true)"
          >Gerar NFC-e (F2)</v-btn
        > -->
        <!-- <v-btn
          color="success"
          outlined
          class="mr-1 ml-1"
          :loading="$store.getters.getOverlay"
          v-if="
            getVenda.estado_nfce == 'APROVADO' &&
            $helper.verificaPermissao('imprimir-nfce')
          "
          @click="imprimirNFCe(getVenda.id)"
          >Imprimir NFC-e (F2)</v-btn
        > -->
        <v-btn
          color="success"
          outlined
          class="mr-1 ml-1"
          :loading="$store.getters.getOverlay"
          @click="imprimirVendaCupomNaoFiscal(getVenda.id)"
          v-if="
            $helper.verificaPermissao('imprimir-cupom-venda') &&
            getVenda.status != 'Excluído'
          "
          id="btn-imprimir-cupom"
          >Cupom (F3)</v-btn
        >

        <!--<v-btn
          color="default"
          outlined
          class="mr-1 ml-1"
          :loading="$store.getters.getOverlay"
          @click="imprimirContrato"
          >Contrato (F4)</v-btn
        >-->
        <v-menu bottom left transition="slide-y-transition" class="ml-10 mr-10" v-if="getVenda.status != 'Excluído'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-item
              @click="setModalEnviarNfeEmail(true)"
              v-if="
                getVenda.estado_nfce == 'APROVADO' ||
                getVenda.estado_nfe == 'APROVADO'
              "
            >
              <v-list-item-action>
                <v-icon>send</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Enviar nota por email.</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <!-- <v-list-item
              @click="setModalCancelarNfe(true)"
              v-if="getVenda.estado_nfe == 'APROVADO'"
            >
              <v-list-item-action>
                <v-icon>clear</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cancelar NF-e.</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <!-- <v-list-item
              @click="setModalEstornoNfe(true)"
              v-if="getVenda.estado_nfe == 'APROVADO'"
            >
              <v-list-item-action>
                <v-icon>clear</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Estonar NF-e.</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <!-- <v-list-item
              @click="imprimirNfe(getVenda.chave_nfe_estorno)"
              v-if="getVenda.estado_nfe == 'ESTORNADA'"
            >
              <v-list-item-action>
                <v-icon>local_printshop</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Imprimir NF-e de estorno.</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <!-- <v-list-item
              @click="setModalCancelarNfce(true)"
              v-if="getVenda.estado_nfce == 'APROVADO'"
            >
              <v-list-item-action>
                <v-icon>clear</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cancelar NFC-e.</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item
              v-if="$helper.verificaPermissao('excluir-venda')"
              @click="setModalExclusaoVenda(true)"
              
            >
              <v-list-item-action>
                <v-icon>clear</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Excluir Venda.</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="$helper.verificaPermissao('atualizar-venda')"
              @click="editarVenda(getVenda.id)"
             
            >
              <v-list-item-action>
                <v-icon>edit</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Editar Venda.</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
              v-if="$helper.verificaPermissao('imprimir-checklist-produto-venda')"
              @click="imprimirCheckListProduto()"
            >
              <v-list-item-action>
                <v-icon>print</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Imprimir check list produtos.</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <!-- <v-list-item
              v-if="$helper.verificaPermissao('imprimir-formulario-checklist')"
              @click="imprimirFormularioPesquisaSatisfacao()"
            >
              <v-list-item-action>
                <v-icon>print</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Imprimir check list venda.</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <!-- <v-list-item
              v-if="$helper.verificaPermissao('cadastrar-pesquisa-satisfacao')"
              @click="cadastrarPesquisaSatisfacao(true)"
            >
              <v-list-item-action>
                <v-icon>quiz</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Pesquisa de Satisfação.</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
          </v-list>
        </v-menu>
        <!-- </span> -->
      </v-card-actions>
    </v-card>
    <ModalGerarNfe />
    <ModalCadastroProduto v-if="getModalCadastroProduto" />
    <ModalCadastroContato />
    <ModalGerarNfce />
    <ModalEnviarNfeEmail />
    <ModalCancelarNfe />
    <ModalCancelarNfce />
    <ModalExclusaoVenda />
    <ModalEstornoNfe />
    <ModalCadastroPosVenda />
    <ModalGerarCartaCorrecao />
    <ModalPesquisaSatisfacao />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalGerarNfe from "@/pages/nfe/nfe/ModalGerar";
import ModalGerarNfce from "@/pages/nfe/nfce/ModalGerar";
import ModalCadastroProduto from "@/pages/produto/ModalCadastro";
import ModalCadastroContato from "@/pages/contato/ModalCadastro";
import ModalEnviarNfeEmail from "@/pages/nfe/ModalEnviarEmail";
import ModalCancelarNfe from "@/pages/nfe/nfe/ModalCancelar";
import ModalCancelarNfce from "@/pages/nfe/nfce/ModalCancelar";
import ModalExclusaoVenda from "@/pages/venda/ModalExclusao";
import ModalEstornoNfe from "@/pages/nfe/nfe/ModalEstorno";
import ModalCadastroPosVenda from "@/pages/crm/posVenda/ModalCadastro";
import ModalGerarCartaCorrecao from "@/pages/nfe/nfe/ModalGerarCartaCorrecao";
import ModalPesquisaSatisfacao from "@/pages/crm/pesquisaSatisfacao/ModalCadastro";

export default {
  components: {
    ModalGerarNfe,
    ModalCadastroProduto,
    ModalCadastroContato,
    ModalGerarNfce,
    ModalEnviarNfeEmail,
    ModalCancelarNfe,
    ModalCancelarNfce,
    ModalExclusaoVenda,
    ModalEstornoNfe,
    ModalCadastroPosVenda,
    ModalGerarCartaCorrecao,
    ModalPesquisaSatisfacao,
  },
  data() {
    return {
      itens_devolvidos: [],
    };
  },
  watch: {
    getContato: function () {
      if (this.getContato.id) {
        this.getVenda.cliente = { ...this.getContato };
      }
    },
    getModalVisualizarVenda() {
      if (this.getModalVisualizarVenda == false) {
        this.cadastrarVenda();
        document.removeEventListener("keydown", this.keyUp);
      } else {
        document.addEventListener("keydown", this.keyUp);
      }
    },
  },
  computed: {
    ...mapGetters([
      "getModalVisualizarVenda",
      "getVenda",
      "getEmpresaSelecionada",
      "getModalListarVenda",
      "getContrato",
      "getModalCadastroContato",
      "getContato",
      "getModalGerarNfe",
      "getModalCadastroProduto",
      "getFormularioPesquisaSatisfacao",
      "getCheckListProdutoVenda"
    ]),
  },
  methods: {
    ...mapActions([
      "setModalVisualizarVenda",
      "imprimirVendaCupomNaoFiscal",
      "setModalGerarNfe",
      "imprimirNfe",
      "visualizarProduto",
      "visualizarContato",
      "imprimirNFCe",
      "setModalTrocaVenda",
      "setModalListarVenda",
      "consultarTrocaVenda",
      "gerarContratoInstalacaoPiscina",
      "visualizarVenda",
      "atualizarContato",
      "setModalGerarNfce",
      "cadastrarVenda",
      "setModalEnviarNfeEmail",
      "setModalCancelarNfe",
      "setModalCancelarNfce",
      "setModalExclusaoVenda",
      "setModalEstornoNfe",
      "editarVenda",
      "cadastrarPosVenda",
      "setModalCartaCorrecaoNfe",
      "cadastrarPesquisaSatisfacao",
      "gerarFormularioPesquisaSatisfacao",
      "imprimirCheckListProdutoVenda",
    ]),
    imprimirContrato() {
      this.gerarContratoInstalacaoPiscina(this.getVenda.id).then((res) => {
        if (this.getContrato.doc_link) {
          window.open(this.getContrato.doc_link);
          this.getContrato.doc_link = "";
        }
      });
    },
    imprimirFormularioPesquisaSatisfacao() {
      this.gerarFormularioPesquisaSatisfacao(this.getVenda.id).then((res) => {
        if (this.getFormularioPesquisaSatisfacao.doc_link) {
          window.open(this.getFormularioPesquisaSatisfacao.doc_link);
          this.getFormularioPesquisaSatisfacao.doc_link = "";
        }
      });
    },
    imprimirCheckListProduto(){
      this.imprimirCheckListProdutoVenda(this.getVenda.id)
      .then(res => {
        if(this.getCheckListProdutoVenda.doc_link){
          window.open(this.getCheckListProdutoVenda.doc_link);
          this.getCheckListProdutoVenda.doc_link = ""
        }
      })
    },
    trocarMercadoria() {
      this.consultarTrocaVenda(this.getVenda.id).then((res) => {
        this.setModalTrocaVenda(true);
        this.setModalVisualizarVenda(false);
        this.setModalListarVenda(false);
      });
    },
    baixarXmlNFe(path_xml) {
      window.open(`${this.$urlApp}/xml_nfe/${path_xml}`, "Download");
    },
    baixarXmlNFCe(path_xml) {
      window.open(`${this.$urlApp}/xml_nfce/${path_xml}`, "Download");
    },
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;
      if (keyCode == 27) e.preventDefault();
      if (keyCode == 112) e.preventDefault();
      if (keyCode == 113) e.preventDefault();
      if (keyCode == 114) e.preventDefault();
      if (keyCode == 115) e.preventDefault();
      // if (keyCode == 97) e.preventDefault();
      // if (keyCode == 98) e.preventDefault();
      // if (keyCode == 99) e.preventDefault();
      // if (keyCode == 100) e.preventDefault();

      if (keyCode == 112) {
        if (!this.getModalGerarNfe && this.getVenda.estado_nfe == "APROVADO") {
          this.imprimirNfe(this.getVenda.chave_nfe);
        } else {
          this.setModalGerarNfe(true);
        }
      }

      if (keyCode == 113 && this.getModalVisualizarVenda == true) {
        if (!this.getModalGerarNfe && this.getVenda.estado_nfe == "APROVADO") {
          this.imprimirNFCe(this.getVenda.id);
        } else {
          this.setModalGerarNfce(true);
        }
      }

      if (keyCode == 114 && this.getModalVisualizarVenda == true) {
        this.imprimirVendaCupomNaoFiscal(this.getVenda.id);
      }

      if (keyCode == 115) {
        this.imprimirContrato();
      }

      if (keyCode == 27) {
        this.$store.dispatch("ativaModalConfirmacao", {
          mensagem: "Tem certeza que deseja voltar?",
          action: "setModalVisualizarVenda",
          action_value: false,
        });
      }
    },
  },
};
</script>
